module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/apprenticePointingUp2-9c0ac37f7e4a051b551e8d86a6fbf1fb.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/apprenticePointingUp2.png
// module id = 2481
// module chunks = 2